<template>
    <span>{{ displayName }}</span>
</template>

<script>
import { contactNameFilter } from '@/vue/filters/contactNameFilter';

export default {
    name: 'ContactName',

    props: {
        /**
         * @type {Contact}
         */
        contact: {
            type: Object,
            required: true,
        },
    },

    computed: {
        /**
         * @return {string}
         */
        displayName() {
            return contactNameFilter(this.contact);
        },
    },
};
</script>
